import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Nav = ({ routes }) => {
  const [active, setActive] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const pathToActiveMap = {
      "/Notification": 5,
      "/Payment": 1,
      "/Entry": 2,
      "/Discharge": 3,
      "/Request": 4,
      "/Dashboard": 0,
      "/Admin": 6,
      "/Activity": 7,
      "/RequestTransfer": 8,
      "/Report": 9,
      "/HistoryPayments": 10,
      "/Summary": 11
    };
    
    setActive(pathToActiveMap[location.pathname] || 0);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-gray-900 w-full shadow-lg">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">

          {/* Logo móvil */}
          <div className="flex items-center lg:hidden">
            <img
              className="h-9 w-auto"
              src="https://intranet.iumv.edu.mx/logo_iumv.png"
              alt="IUMV"
            />
          </div>

          {/* Desktop nav */}
          <div className="hidden lg:flex lg:items-center lg:gap-1 flex-1">
            {routes.map((item) => (
              <Link
                key={item.key}
                to={item.key}
                className={`relative px-4 py-4 text-xs font-semibold tracking-wide uppercase transition-colors duration-150 ${
                  active === item.active
                    ? 'text-white'
                    : 'text-gray-400 hover:text-white hover:bg-gray-800'
                }`}
                style={active === item.active ? { borderBottom: '2px solid #dc2626', marginBottom: '-2px' } : {}}
              >
                {item.icon && <i className={item.icon} style={{ fontSize: '11px', marginRight: '4px' }}></i>}
                {item.name}
              </Link>
            ))}
          </div>

          {/* Cerrar sesión desktop */}
          <div className="hidden lg:flex items-center ml-4">
            <Link
              to="Login"
              className="flex items-center gap-2 px-4 py-2 text-xs font-semibold tracking-wide uppercase text-gray-400 hover:text-red-400 transition-colors duration-150 border border-gray-700 hover:border-red-600 rounded"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Salir
            </Link>
          </div>

          {/* Hamburguesa móvil */}
          <div className="flex items-center lg:hidden">
            <button
              onClick={toggleMenu}
              className="p-2 rounded text-gray-400 hover:text-white hover:bg-gray-800 focus:outline-none transition-colors"
            >
              <span className="sr-only">Abrir menú</span>
              {isOpen ? (
                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Móvil dropdown */}
      <div className={`${isOpen ? 'block' : 'hidden'} lg:hidden bg-gray-800 border-t border-gray-700`}>
        <div className="py-2 px-4 space-y-1">
          {routes.map((item) => (
            <Link
              key={item.key}
              to={item.key}
              onClick={() => setIsOpen(false)}
              className={`block px-3 py-2.5 text-sm font-medium rounded transition-colors duration-150 ${
                active === item.active
                  ? 'bg-red-600 text-white'
                  : 'text-gray-300 hover:text-white hover:bg-gray-700'
              }`}
            >
              {item.icon && <i className={item.icon} style={{ fontSize: '12px', marginRight: '6px' }}></i>}
              {item.name}
            </Link>
          ))}
          <Link
            to="Login"
            onClick={() => setIsOpen(false)}
            className="block px-3 py-2.5 text-sm font-medium text-gray-400 hover:text-red-400 hover:bg-gray-700 rounded transition-colors duration-150"
          >
            Cerrar Sesión
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Nav;